var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/instagram_small.7a9573b1.png","uri@2x": __webpack_public_path__ + "static/media/instagram_small.f382064b.png","uri@3x": __webpack_public_path__ + "static/media/instagram_small.52d1fa7e.png",
    width: 12,
    height: 12
});